export default "__VITE_ASSET__Co5nELaA__"